import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

const RtTooltip = (props) => {
  const [show, setShow] = React.useState(false)
  const tooltipId = _.uniqueId('tooltip-')

  return props.message ? (
    <OverlayTrigger
      show={show && !props.isDisabled}
      placement={props.placement || 'auto'}
      trigger={props.trigger}
      delay={props.delay}
      overlay={<Tooltip id={tooltipId}>{props.message}</Tooltip>}
      onToggle={setShow}
    >
      {props.children}
    </OverlayTrigger>
  ) : (
    props.children
  )
}

RtTooltip.propTypes = {
  isDisabled: PropTypes.bool,
  message: PropTypes.node,
  placement: PropTypes.string,
  trigger: PropTypes.string,
  delay: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      show: PropTypes.number,
      hide: PropTypes.number,
    }),
  ]),
  children: PropTypes.node.isRequired,
}

export default RtTooltip
